import { catMeta } from "@/lib/constants";

export const CategoryBadge = ({ category, className = "" }) => {
  const m = catMeta(category);
  const Icon = m.icon;
  return (
    <span data-testid="category-badge" className={`inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.15em] font-code px-2 py-0.5 rounded border ${m.bg} ${m.border} ${m.text} ${className}`}>
      <Icon className="w-3 h-3" />
      {category}
    </span>
  );
};
